module.exports = "/_next/static/images/video_id_7170165246424861994-418ff7336cd7d49ab6806312d3701251.jpg";